import { combineEpics } from "redux-observable";
import { upsellMessageListLoadEpicReducer } from "../ducks/upsellMessageList.duck.js";
const upsellMessageListEpic = combineEpics(upsellMessageListLoadEpicReducer.epic);
export {
  upsellMessageListEpic
};
//# sourceMappingURL=upsellMessageList.epics.js.map
